// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"OwnModal_modal_wrapper__0pXz7","close_icon":"OwnModal_close_icon__B4BKQ","own_modal":"OwnModal_own_modal__JJLsx"};